/**
 * Groups an array of objects by a specified key.
 * @param array - The array to group
 * @param key - The key to group by
 * @returns An object with keys being the unique values of the specified key
 */
export const groupBy = <T extends Record<string, any>>(
  array: T[],
  key: keyof T
): Record<string, T[]> => {
  return array.reduce((result, currentValue) => {
    const groupKey = String(currentValue[key]);
    (result[groupKey] = result[groupKey] || []).push(currentValue);
    return result;
  }, {} as Record<string, T[]>);
};

/**
 * Removes an item from an array at the specified index.
 * Returns a new array without mutating the original.
 */
export const removeAtIndex = <T>(array: T[], index: number): T[] => {
  const result = [...array];
  result.splice(index, 1);
  return result;
};

/**
 * Updates an item in an array at the specified index.
 * Returns a new array without mutating the original.
 */
export const updateAtIndex = <T>(array: T[], index: number, item: T): T[] => {
  const result = [...array];
  result[index] = item;
  return result;
};

/**
 * Inserts an item into an array at the specified index.
 * Returns a new array without mutating the original.
 */
export const insertAtIndex = <T>(array: T[], index: number, item: T): T[] => {
  const result = [...array];
  result.splice(index, 0, item);
  return result;
};
